// TelcoTrack — Změny oproti PD. Saved profile `sections.pd-changes.view`.

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { permissionAllows } from '@core/shared-bridge';

export const pdChangesGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.getCurrentUser();
  if (permissionAllows(user?.permissionProfile, 'pd-changes', 'view')) {
    return true;
  }
  return router.createUrlTree(['/403']);
};
